<template>
  <div
    class="wrapper"
    :style="wrapperStyle"
    @click="!!props.isClickable && sendToMessengerBot(link[props.msgr])"
  >
    <component
      :is="componentState"
      :width="width"
      :height="height"
      :iconColor="colorIconState"
    >
    </component>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import TelegramIcon from "@/components/Icons/messengerComponent/TelegramIcon";
import ViberIcon from "@/components/Icons/messengerComponent/ViberIcon";

const link = {
  telegram: "https://t.me/echat_support_bot",
  viber: "viber://pa?chatURI=echat",
};

const components = {
  telegram: TelegramIcon,
  viber: ViberIcon,
};

const props = defineProps({
  msgr: {
    type: String,
    required: true,
  },
  width: {
    type: [Number, String],
    default: 16,
  },
  height: {
    type: [Number, String],
    default: 16,
  },
  bgColor: {
    type: String,
    default: null,
  },
  iconColor: {
    type: String,
    default: null,
  },
  isClickable: {
    type: Boolean,
    default: true,
  },
});

const componentState = computed(() => components[props.msgr]);

const linkState = computed(() => {
  return link[props.msgr];
});

const sendToMessengerBot = (link) => {
  window.open(link, "_blank");
};

const colorIconState = computed(() =>
  props.bgColor ? "white" : props.iconColor
);

const wrapperStyle = computed(() => ({
  width: `${props.width}px`,
  height: `${props.height}px`,
  backgroundColor: props.bgColor || "none",
  cursor: props.isClickable ? "pointer" : "inherit",
  padding: props.bgColor && "12px",
}));
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  //margin-left: 8px;
}
</style>
